import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";

// Default fallback used when the DB hasn't been seeded yet
export const DEFAULT_COLLECTIONS_QUERIES = [
  {
    heading: "Styles for any Event",
    query: "women's black dress for party",
    gender: "Women",
  },
  {
    heading: "Shop by your Budget",
    query: "unstitched 3 piece lawn suits under 5000",
    gender: "Women",
  },
  {
    heading: "Effortless Outfit Matching",
    query: "formal sandals and shoes to pair with eastern wear",
    gender: "Women",
  },
];

export const fetchCollections = createAsyncThunk(
  "collections/fetchCollections",
  async (queriesConfig, { rejectWithValue }) => {
    try {
      const queries = queriesConfig || DEFAULT_COLLECTIONS_QUERIES;
      const search = queries.map((item) => item.query);
      const genders = queries.map((item) => item.gender || "Women");

      const response = await axios.get(
        `${config.backendUrl}/inventory/batch_search`,
        {
          params: { q: search, gender: genders },
        },
      );

      return {
        responses: response.data?.results?.responses || [],
        configUsed: queries,
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch collections",
      );
    }
  },
);

const initialState = {
  collections: [],
  lastFetchedConfig: null,
  loading: false,
  error: null,
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCollections: (state) => {
      state.collections = [];
      state.lastFetchedConfig = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.collections = action.payload.responses;
        state.lastFetchedConfig = action.payload.configUsed;
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCollections } = collectionsSlice.actions;
export default collectionsSlice.reducer;
